import axios from "axios";

export const getStockTradingSignalsFlags = async (id: number, params: any) => {
    const defaultParams = { page_size: 18, sortModel: { st_date: "asc" } };
    const res = await axios.get(`/API/v2/id/${id}/alpha/list/signals_v2?dgformat&return_flags`, {
        params: {
            ...defaultParams,
            customFilterModel: { items: params.items },
            page: params.page,
        },
    });
    return res.data;
};
